import WebGLDisk from './WebGLDisk';
import './Footer.css';

function Footer({ content }) {
  // Default social and contact data if content is not provided
  const defaultSocials = [
    { platform: 'Instagram', url: 'https://www.instagram.com/road_nds/' },
    { platform: 'LinkedIn', url: 'https://www.linkedin.com/in/robin-gardeur-le-shka-949108144/' }
  ];

  const defaultContacts = [
    { type: 'email', value: 'robin.leshka@gmail.com' },
    { type: 'phone', value: '+44 7 491 658 644' }
  ];

  const socials = content?.socials || defaultSocials;
  const contacts = content?.contacts || defaultContacts;

  return (
    <div className="footer">
      <div className="title footer-title">
        <a className="contact-me" href="mailto:robin.leshka@gmail.com">
          <div className="contact-text-container">
            <div className="contact-text-top">CONTACT</div>
            <div className="contact-text-bottom">CONTACT</div>
          </div>
          <WebGLDisk responsiveSize="calc((100vw / 12.5) - 0.45rem)" />
          <div className="contact-text-container">
            <div className="contact-text-top">ME</div>
            <div className="contact-text-bottom">ME</div>
          </div>
        </a>
      
        <div className="links">
          <div className="socials">
            {socials.map((social, index) => (
              <a key={index} href={social.url} className="link-mask" target="_blank" rel="noopener noreferrer">
                <div className="link-line">
                  <div className="link-text-top">{social.platform}</div>
                  <div className="link-text-bottom">{social.platform}</div>
                </div>
              </a>
            ))}
          </div>
          <div className="contacts">
            {contacts.map((contact, index) => (
              <a 
                key={index} 
                href={contact.type === 'email' ? `mailto:${contact.value}` : `tel:${contact.value}`} 
                className="link-mask"
              >
                <div className="link-line">
                  <div className="link-text-top">{contact.value}</div>
                  <div className="link-text-bottom">{contact.value}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer; 